import { gql } from "@apollo/client";
import {TRANSLATED_STRING_FIELDS} from "../fragments/common"
import {PRICING_CATALOG_FIELDS} from "../fragments/pricing"
import {DELIVERY_UNIT_SALE_CATALOG_FIELDS} from "../fragments/producer"
import {PLATFORM_MERCHANT_CONTRACT_FIELDS} from "../fragments/contract"

// --------------------------------------------------------- Platform sale catalog ---------------------------------------------------------
export const PLATFORM_SALE_CATALOG_FIELDS = gql`
${TRANSLATED_STRING_FIELDS}
${PRICING_CATALOG_FIELDS}
${DELIVERY_UNIT_SALE_CATALOG_FIELDS}
fragment PlatformSaleCatalogFields on PlatformSaleCatalog {
    id
    name {...TranslatedStringFields}
    description {...TranslatedStringFields}
    deliveryUnitSaleCatalog {...DeliveryUnitSaleCatalogFields}
    platformSellingPricingCatalogs {...PricingCatalogFields}
    merchantReferenceRetailPricingCatalogs {...PricingCatalogFields}
    createdAt
    publishedAt
    updatedAt
    isPublished
  }`

  export const PLATFORM_SALE_CATALOG_WITH_PLATFORM_MERCHANT_CONTRACT_FIELDS = gql`
${PLATFORM_SALE_CATALOG_FIELDS}
${PLATFORM_MERCHANT_CONTRACT_FIELDS}
fragment PlatformSaleCatalogWithPlatformMerchantContractFields on PlatformSaleCatalogWithPlatformMerchantContract {
    platformSaleCatalog {...PlatformSaleCatalogFields}
    platformMerchantContract {...PlatformMerchantContractFields}
    platformSaleCatalogPublished
    platformMerchantContractActive
}`
